import { FC } from "react";

import {
  QuestionComponentProps,
  TestQuestionFrontType,
  useTestSolutionActionsContext,
  useTestSolutionValuesContext,
} from "../../../../../../model";
import {
  ClosedMany,
  ClosedOne,
  Matching,
  Open,
  Sequence,
  Survey,
} from "./components";

const COMPONENT_BY_TYPE: Record<
  TestQuestionFrontType,
  FC<QuestionComponentProps>
> = {
  [ TestQuestionFrontType.Open ]: Open,
  [ TestQuestionFrontType.ClosedOne ]: ClosedOne,
  [ TestQuestionFrontType.ClosedMany ]: ClosedMany,
  [ TestQuestionFrontType.Sequence ]: Sequence,
  [ TestQuestionFrontType.Survey ]: Survey,
  [ TestQuestionFrontType.Matching ]: Matching,
};

export const QuestionByType: FC = () => {
  const {
    questionType,
    answers,
    userAnswer,
    isFileUpload,
    fileAnswer,
    error,
    currentQuestion,
  } = useTestSolutionValuesContext();

  const {
    setUserAnswer,
    setFileAnswer,
    setError,
  } = useTestSolutionActionsContext();

  if (!questionType) {
    return null;
  }

  const Component = COMPONENT_BY_TYPE[ questionType ];

  if (!Component) {
    return null;
  }

  return (
    <Component
      key={currentQuestion.uid}
      answers={answers}
      currentQuestion={currentQuestion}
      error={error}
      fileAnswer={fileAnswer}
      isFileUpload={isFileUpload}
      setError={setError}
      setFileAnswer={setFileAnswer}
      setUserAnswer={setUserAnswer}
      userAnswer={userAnswer}
    />
  );
};
